import { render, staticRenderFns } from "./cabecerados.vue?vue&type=template&id=55f5b5ce&"
import script from "./cabecerados.vue?vue&type=script&lang=js&"
export * from "./cabecerados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports